// src/assets/js/pages/quizzes/main.js

import { initHeaderActiveNav, initHeaderCTA } from '../common/header.js';
import { QuizzesState } from './bom/QuizzesState.js';
import { QuizzesController } from './controllers/QuizzesController.js';
import { QuizzesView } from './ui/QuizzesView.js';

document.addEventListener('DOMContentLoaded', () => {
	//Header
	initHeaderActiveNav();
	initHeaderCTA();

	//Main Content
	const root = document.querySelector('[data-quizzes-root]');
	if (!root) {
		console.warn('[quizzes/main] Root [data-quizzes-root] not found');
		return;
	}

	const initial = readInitialStateFromURL();

	const state = new QuizzesState({
		...initial,
		//forzar page size
		// pageSize: 10,
	});

	const view = new QuizzesView({ root });
	const controller = new QuizzesController({ root, state, view });
	controller.init();
});

function readInitialStateFromURL() {
	const url = new URL(window.location.href);

	const subjectId = url.searchParams.get('subject') || null;
	const regionId = url.searchParams.get('region') || null;
	const query = (url.searchParams.get('q') || '').trim();

	// Regla UX: subject o query => lista
	const viewMode = subjectId || query ? 'list' : 'subjects';

	return { subjectId, regionId, query, viewMode };
}
